import React from 'react'
import trophy from '../../../../../assets/trophy.png'

const TopEvent = ({topEvent}) => {
  return (
    <div style={{display:"flex", justifyContent:"space-around"}}>
    <div style={{width:"30%",marginTop:"1em"}}>
       <h3>Top Event</h3>
       <h5 style={{marginTop:"0.4em"}}>{topEvent?.title}</h5>
       <p style={{fontSize:"0.8rem",marginTop:"0.8em"}}>Tag: <b>{topEvent?.tag}</b></p>
       </div>
    
    <div>
       
    </div>

    <div style={{ height: '10vh' , width:"30%",marginTop:"1em"}}>
    
        <img src={trophy} alt='top' />
        <p style={{fontSize:"0.8rem"}}>Income: <b>£ {topEvent?.income}</b> </p>
        <p style={{fontSize:"0.8rem"}}>Tickets Sold: <b>{topEvent?.ticketSold}</b></p>
      
    </div>

</div>

  )
}

export default TopEvent